export default __webpack_public_path__ + "assets/front/scss/error.d6f3e64c1cbf4e5832624fcade3838e2.css";